import Validator from '../validation/Validator';

export default {
    render(data, event) {
        const props = {
            type: data.type || 'text',
            placeholder: data.placeholder || '',
            value: container.componentList.FirebaseStorage.data()[data.bind] || '',
        };

        // Disable email inputs if the start with a value
        // To prevent email updates on the profile page
        // if (props.type === 'email' && !!props.value) {
        //     props.disabled = 'true';
        // }

        const element = document.createElement('input');
        element.classList.add('form-control');
        Object.entries(props).forEach(function(pair) {
            element.setAttribute(pair[0], pair[1]);
        });

        return element;
    },
    postRender(element, type, data, container, event) {
        Logger.info("Snippet.Input", element, type, data, container, event);
        if (data.label) {
            const label = document.createElement('label');
            label.innerText = data.label;
            element.parentElement.insertBefore(label, element);
        }

        const validator = new Validator(data.bind, null, {element});
        // const state = container.componentList.FirebaseStorage.data();

        const focusHandler = () => {
            validator.clearHints();
        };

        const validationHandler = () => {
            var newValue = null;

            Logger.info("Validation.Input.validationHandler", type, element)
            if( new Array("text", "email").includes( element.type ) ) {
				newValue =  element.value;
                validator.value(newValue);
            } else if( element.type == "checkbox" ) {
			    newValue = element.checked;
                validator.value( newValue == true ? "checked" : "" );
            }

            validator.validate();
            if (validator.valid()) {
				// state[data.bind] = element.value;

				Logger.info("Binding to ", data.bind, element.value, newValue);
				container.componentList.FirebaseStorage.setUserProperty(data.bind, newValue);
            }
        };

        const enterHandler = e => {
            if (e.key !== 'Enter') {
                return;
            }

            if (validator.valid()) {
                event.view.next();
            }
        };

        // Add the default value
        // container.componentList.FirebaseStorage.setUserProperty(data.bind, element.value);

        element.addEventListener('focus', focusHandler);
        element.addEventListener('blur', validationHandler);
        element.addEventListener('input', validationHandler);
		element.addEventListener('keypress', enterHandler);

		Backbone.listenToOnce( container.session.currentPageData.getBlock(0).view, "onDestroy", (e)=> {
			element.removeEventListener('focus', focusHandler);
			element.removeEventListener('blur', validationHandler);
			element.removeEventListener('input', validationHandler);
			element.removeEventListener('keypress', enterHandler);
		});
    },
    destroy(element) {

    }
};